import Button from '../../../Button';
import styled from '@emotion/styled';
import { breakpoints } from '~/theme/breakpoints';
import { Input } from '~/shared/components/form';
import { theme } from '~/theme';
import Checkmark from '~/icons/checkmark.svg';

export const DialogContainer = styled.div(() => ({
    paddingLeft: theme.space[5],
    paddingRight: theme.space[5],
    paddingTop: theme.space[2],
    paddingBottom: theme.space[4],
}));

export const StyledFormWrapper = styled.div({
    paddingTop: theme.space[5],
    display: 'flex',
    flexDirection: 'column',
});

export const Label = styled.label({
    width: 'fit-content',
    padding: theme.space[2],
    borderTop: '1px solid',
    borderLeft: '1px solid',
    borderRight: '1px solid',
    borderBottom: 'none',
    borderRadius: `${theme.space[1]} ${theme.space[1]} 0 0`,
    fontSize: theme.fontSizes['xs'],
});

export const StyledInput = styled(Input)({
    border: `1px solid ${theme.colors.black}`,
    padding: `${theme.space[2]} ${theme.space[3]}`,
});

export const Paragraph = styled.p({
    paddingTop: theme.space[2],
});

export const StyledButton = styled(Button)({
    marginTop: theme.space[2],
});

export const TriggerButton = styled(Button)(() => ({
    marginBottom: 0,
    flex: `1 1 50%`,
    [breakpoints.md]: {
        marginBottom: theme.space[2],
    },
}));

export const StyledCheckmark = styled(Checkmark)(() => ({
    background: theme.colors.black,
    color: theme.colors.white,
    borderRadius: '50%',
    width: theme.space[5],
    padding: theme.space[1],
    height: theme.space[5],

    [breakpoints.md]: {
        padding: theme.space[2],
    },
}));

export const StyledSubmitSuccess = styled.div(() => ({
    display: 'flex',
    flexFlow: 'column nowrap',
}));

export const StyledContentWrapper = styled.div(() => ({
    display: 'flex',
    padding: `${theme.space[4]} 0`,
    flexDirection: 'column',
    alignItems: 'flex-start',

    '& > *': {
        marginBottom: theme.space[2],
    },
}));

export const StyledEmailPolicy = styled.div(() => ({
    fontSize: theme.fontSizes['2xs'],
    display: 'flex',
    flexFlow: 'column nowrap',
    margin: `${theme.space[2]} 0`,
    '& > *': {
        paddingTop: theme.space[1],
    },
}));
